import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { handleLogout } from '@/features/auth/lib/authSession';
import { useGetUserQuery } from '@/api/rtk/userApi';
import {
  selectUserData,
  selectUserFailed,
  selectUserLoading,
} from '@/api/rtk/userSelectors';

export function useEnsureUser({ forceFetch = false } = {}) {
  const userId = localStorage.getItem('user_id');
  const skip = !userId || userId === 'undefined';

  useGetUserQuery(
    { userId },
    {
      skip,
      refetchOnMountOrArgChange: forceFetch,
    }
  );

  const user = useSelector(selectUserData);
  const userLoading = useSelector(selectUserLoading);
  const userFailed = useSelector(selectUserFailed);

  useEffect(() => {
    if (!!userId && userFailed) {
      handleLogout();
    }
  }, [userId, userFailed]);

  return { userId, user, userLoading, userFailed };
}
